import { render, staticRenderFns } from "./CLanguagePair.vue?vue&type=template&id=f62e8a70&scoped=true&"
import script from "./CLanguagePair.vue?vue&type=script&lang=js&"
export * from "./CLanguagePair.vue?vue&type=script&lang=js&"
import style0 from "./CLanguagePair.vue?vue&type=style&index=0&id=f62e8a70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62e8a70",
  null
  
)

export default component.exports